import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DarkModeSwitch = _resolveComponent("DarkModeSwitch")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_NeedAlgoSigner = _resolveComponent("NeedAlgoSigner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DarkModeSwitch, {
      onSwitched: _ctx.onSwitched,
      initialState: _ctx.isDarkModeEnabled
    }, null, 8, ["onSwitched", "initialState"]),
    _createVNode(_component_NavBar, { text: "Algo-Votes" }),
    _createVNode(_component_router_view),
    (_ctx.hasAlgoSigner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_NeedAlgoSigner, { key: 1 }))
        : _createCommentVNode("", true)
  ], 64))
}